module.exports = __webpack_public_path__ + "static/media/dancing-baby.fbc8bac6.gif";